// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupProfile__container-faba97 {
  --padding: 24px;
}

.GroupProfile__header-b77f61 {
  display: flex;
  padding-bottom: 12px;
  padding-inline-start: var(--padding);
}

.GroupProfile__avatar-bc0dc8 {
  display: flex;
  align-items: flex-start;
  margin-inline-end: 16px;
}

.GroupProfile__info-a5cb18 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
}

.GroupProfile__verified-e09a97 {
  display: inline-block;
  vertical-align: middle;
}

.GroupProfile__title-fdd5f2 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--base-110);
  word-break: break-all;
}

.GroupProfile__subtitle-cfbf5b {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  margin-top: 4px;
}

.GroupProfile__actions-b80d62 {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 24px 16px;
}

.GroupProfile__action-button-a0056f {
  margin-inline-start: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.GroupProfile__action-button-icon-ce9933 {
  display: flex;
  align-items: center;
}

.GroupProfile__contact-fa81b6 {
  padding: 8px var(--padding);
}

.GroupProfile__list-item-cc52dd {
  min-height: 48px;
  padding: 0 var(--padding);
}

.GroupProfile__list-item-title-dc2bff {
  margin-inline-start: 8px;
}

.GroupProfile__list-icon-ce45bb {
  fill: var(--base-80);
}

.GroupProfile__secure-icon-ec911e {
  margin-inline-end: 6px;
}

.GroupProfile__learn-more-e1e689 {
  color: var(--brand-secondary-40);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/GroupProfile/GroupProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,gCAAA;EACA,eAAA;AACF","sourcesContent":[".container {\n  --padding: 24px;\n}\n\n.header {\n  display: flex;\n  padding-bottom: 12px;\n  padding-inline-start: var(--padding);\n}\n\n.avatar {\n  display: flex;\n  align-items: flex-start;\n  margin-inline-end: 16px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.verified {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.subtitle {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  margin-top: 4px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px 24px 16px;\n}\n\n.action-button {\n  margin-inline-start: 16px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.action-button-icon {\n  display: flex;\n  align-items: center;\n}\n\n.contact {\n  padding: 8px var(--padding);\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 var(--padding);\n}\n\n.list-item-title {\n  margin-inline-start: 8px;\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n\n.secure-icon {\n  margin-inline-end: 6px;\n}\n\n.learn-more {\n  color: var(--brand-secondary-40);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupProfile__container-faba97`,
	"header": `GroupProfile__header-b77f61`,
	"avatar": `GroupProfile__avatar-bc0dc8`,
	"info": `GroupProfile__info-a5cb18`,
	"verified": `GroupProfile__verified-e09a97`,
	"title": `GroupProfile__title-fdd5f2`,
	"subtitle": `GroupProfile__subtitle-cfbf5b`,
	"actions": `GroupProfile__actions-b80d62`,
	"action-button": `GroupProfile__action-button-a0056f`,
	"actionButton": `GroupProfile__action-button-a0056f`,
	"action-button-icon": `GroupProfile__action-button-icon-ce9933`,
	"actionButtonIcon": `GroupProfile__action-button-icon-ce9933`,
	"contact": `GroupProfile__contact-fa81b6`,
	"list-item": `GroupProfile__list-item-cc52dd`,
	"listItem": `GroupProfile__list-item-cc52dd`,
	"list-item-title": `GroupProfile__list-item-title-dc2bff`,
	"listItemTitle": `GroupProfile__list-item-title-dc2bff`,
	"list-icon": `GroupProfile__list-icon-ce45bb`,
	"listIcon": `GroupProfile__list-icon-ce45bb`,
	"secure-icon": `GroupProfile__secure-icon-ec911e`,
	"secureIcon": `GroupProfile__secure-icon-ec911e`,
	"learn-more": `GroupProfile__learn-more-e1e689`,
	"learnMore": `GroupProfile__learn-more-e1e689`
};
module.exports = ___CSS_LOADER_EXPORT___;
